import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles";

export const leagueTeamTable = style({
  tableLayout: "fixed",
  borderCollapse: "separate",
  borderSpacing: `0 ${vars.space.xs}`,
});

export const leagueTeamHeader = style({
  alignItems: "center",
  padding: `0 ${vars.space.s}`,
  width: "100%",
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.body.xs,
});

export const posCol = style({
  width: "10%",
  textAlign: "center",
  fontSize: vars.fontSizes.body.xs,
});

export const nameCol = style({
  padding: `0 ${vars.space.xs}`,
  width: "65%",
  textAlign: "start",
  fontSize: vars.fontSizes.body.xs,
});

export const scoreCol = style({
  padding: `0 ${vars.space.xs}`,
  width: "25%",
  textAlign: "center",
  textWrap: "nowrap",
  fontSize: vars.fontSizes.body.xs,
});

export const posCell = style({
  borderStartStartRadius: vars.radii.s,
  borderStartEndRadius: 0,
  borderEndStartRadius: vars.radii.s,
  borderEndEndRadius: 0,
  backgroundColor: vars.colors.surfaceVariant,
  padding: `${vars.space.xs} ${vars.space.m}`,
  textAlign: "center",
});

export const nameCell = style({
  backgroundColor: vars.colors.surfaceVariant,
  padding: `${vars.space.xs}`,
});

export const scoreCell = style({
  borderStartStartRadius: 0,
  borderStartEndRadius: vars.radii.s,
  borderEndStartRadius: 0,
  borderEndEndRadius: vars.radii.s,
  backgroundColor: vars.colors.surfaceVariant,
  padding: `${vars.space.xs}`,
  textAlign: "center",
});

export const leagueTeamPosition = style({
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.body.m,
});

export const leagueTeamName = style({
  display: "block",
  width: "100%",
  textAlign: "start",
  fontSize: vars.fontSizes.body.s,
});

export const leagueTeamTableRow = style({
  borderRadius: vars.radii.s,
  textDecoration: "none",
  color: vars.colors.onSurface,
  fontSize: vars.fontSizes.body.m,
});
